import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();

  const links = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Contact Us", path: "/contact" }
  ];

  return (
    <nav className="navbar navbar-expand-lg bg-white shadow-sm py-2 sticky-top">
      <div className="container d-flex align-items-center justify-content-between">

        {/* LEFT - LOGO */}
        <Link className="navbar-brand m-0" to="/">
          <img 
            src="/logo.png"
            alt="Logo"
            style={{ height: "45px", width: "auto" }}
          />
        </Link>

        {/* MOBILE: CALL + MENU in ONE ROW */}
        <div className="d-flex align-items-center d-lg-none ms-auto">

          {/* CALL BUTTON */}
          <a 
            href="/track"
            className="btn btn-danger fw-semibold me-2 py-1 px-2"
            style={{ fontSize: "13px" }}
          >
            TRACK SHIPMENT
          </a>

          {/* MENU TOGGLER */}
          <button 
            className="navbar-toggler m-0 order-last"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

        </div>

        {/* CENTER MENU */}
        <div 
          className="collapse navbar-collapse justify-content-lg-center"
          id="mainNav"
        >
          <ul className="navbar-nav gap-3 text-center">

            {links.map((item) => (
              <li className="nav-item" key={item.path}>
                <Link
                  className={
                    "nav-link fs-5 " + 
                    (location.pathname === item.path ? "fw-bold text-primary" : "")
                  }
                  to={item.path}
                >
                  {item.name}
                </Link>
              </li>
            ))}

          </ul>
        </div>

        {/* DESKTOP - CALL BUTTON */}
        <div className="d-none d-lg-block">
          <a 
            href="/track"
            className="btn btn-danger fw-semibold"
          >
            TRACK SHIPMENT
          </a>
        </div>

      </div>
    </nav>
  );
}
